import React from "react";
import "./index.scss";
import { Link } from "react-router-dom";
import SmallLogo from "../../assets/small-logo.png";
import {
  FacebookOutlined,
  InstagramOutlined,
  LinkedinOutlined,
} from "@ant-design/icons";
import { Divider } from "antd";

function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-links">
        <Link to="">من نحن</Link>
        <Link to="">ماذا نقدم</Link>
        <Link to="">الفريق</Link>
        <Link to="">اتصل بنا</Link>
      </div>
      <Divider />
      <div className="footer-social">
        <div className="footer-social-links">
          <Link to="">
            <FacebookOutlined />
          </Link>
          <Link to="">
            <InstagramOutlined />
          </Link>
          <Link to="">
            <LinkedinOutlined />
          </Link>
          <Link to="">
            <img src={SmallLogo} />
          </Link>
        </div>
        <div>
          <span> جميع الحقوق محفوظة لدى منصة قولانسر 2023 </span>
        </div>
      </div>
    </div>
  );
}

export default Footer;
